<template>
<div>
	<div   ref="boxs" class="msg_box ">
		<div v-if="user.type==1" class="user_vip mar_top_50">
			<div class="vip_left">
				<span class="vip_user a_dase">用户{{user.nickname}}：</span>
				<span>可用积分</span>
				<span class="integral">{{user.usable_score | toInt}}</span>
			</div>
			<p class="vip_right fonta" @click="goBottom">
				积分获得及兑换规则
			</p>
		</div>
		<div v-else class="vip_no">
			<p v-if="user.token" @click="xin.goUrl('/applyVip')" class="fonta">您当前还不是VIP会员，前去申请~</p>
			<p v-else class="fonta" @click="xin.goUrl('/login')">登录后可查看您的可用积分并进行兑换</p>
		</div>
		<div class="one_vessel" v-if="integral">
			<div class="laing_btn " @click="setindex(0)" :class="{'btn_one':index!=0}">全部</div>
			<div class="laing_btn " @click="setindex(i+1)" :class="{'btn_one':index!=i+1}"
			v-for="(item,i) in integral.type" :key="item.id">{{item.value}}积分</div>
		</div>
		<div  v-loading="loading" class="product_list min_he400">
			<div class="pro_zi" v-for="item in integralList" :key="item.id">
				<div class="pro_img">
					<img @click="goint(item.id)" :src="item.cover_img" />
				</div>
				<div class="int_content">
					<span class="">{{item.title}}</span>
					<span class="int_sec">消耗积分{{item.type.value}}</span>
					<el-button v-preventReClick @click="goint(item.id)" icon="iconfont icon-gouwuchekong" plain>积分兑换</el-button>
				</div>
			</div>
		</div>
		<div class="mar_top_50" v-html="integral.rule">
		</div>
	</div>
</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				loading:true,
				index:0,
				isUser:true,//是否登录
				integral:{},//积分对象
				integralList:[],//积分商品
			}
		},
		computed:{
			...mapState(['user','token'])
		},
		created(){
			this.PostintegralList();
		},
		methods:{
			setindex(i){//
				this.index = i;
				this.PostintegralList()
			},
			goBottom(){
				var t = this.$refs.boxs.clientHeight;
				window.scroll({ top: t-400, behavior: 'smooth' });
			},
			goint(id){
				if(!this.user.token) this.xin.goUrl('/login?redirect=/integral')
				else if(this.user.type==1){
					this.xin.goUrl('/integralConvert?id='+id)
				}else{
					this.$message({ message: '您当前还不是VIP会员', type: 'warning' });
				}
			},
			async PostintegralList(){
				this.loading = true;
				let {data} = await this.api.PostintegralList({type:this.index});
				this.integral = data;
				this.integralList = data.integral;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.wsxc{
		font-weight: 500;
		font-size: 20px;
		color: #005599;
	}
	.tech_zdmk{
		margin-top: 20px;
		div{
			color: #666666;
			line-height: 40px;
		}
	}
	.tech_{
		
		
		.tech_left{
			float: left;
			font-weight: 500;
			font-size: 20px;
			color: #333333;
		}
		.tech_right{
			float: right;
			&:hover{
				cursor: pointer;
				color: #000;
			}
		}
	}
	.product_list{
		.pro_zi{
			width: 280px;
			.pro_img{
				height: 210px;
			}
		}
		.int_content{
			.int_sec{
				font-size: 24px;
			}
			span{
				color: #333333;
				margin: 6px 0;
				display: block;
			}
		}
	}
	.one_vessel{
			box-sizing: border-box;
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			.btn_one{
				background: #fff;
				color: #666;
				border: 1px solid #666;
			}
			div{
				margin: 10px 0 0 10px;
				width: 185px;
				height: 50px;
				line-height: 50px;
				border-radius: 0px;
			}
		}
	//无vip
	.vip_no{
		text-align: center;
		color: #B03130;
		font-size: 20px;
		letter-spacing:1.5px
	}
	//有vip
	.user_vip{
		width: 100%;
		display: flex;
		justify-content: space-between;
		.vip_left{
			color: #666666;
			font-size: 24px;
			.vip_user{
				font-size: 24px;
			}
			.integral{
				font-size: 36px;
				color: #B03130;
			}
		}
		.vip_right{
			font-size: 24px;
		}
	}
</style>
